import GenericBody from "../../../Componentes/GenericBody"
import NavBar from "../../../Componentes/NavBar"
import ConteudoFuncaoOs from "./ConteudoFuncaoOs";

const FuncaoOS = () => {

    return(
        <>
            <NavBar title="FUNÇÃO x ORDEM DE SERVIÇO" />
            <GenericBody>
                <ConteudoFuncaoOs />
            </GenericBody>
        </>
    )

}

export default FuncaoOS;